import Vue from 'vue'
import './config/rem'
import './config/util'
import App from './App.vue'

Vue.config.productionTip = false
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueRouter from 'vue-router'


Vue.prototype.$axios = axios
axios.defaults.baseURL = '/api'

Vue.directive('title', {
    inserted: function (el) {
        document.title = el.dataset.title
    }
})

Vue.use(VueAxios, axios, VueRouter)
import VueI18n from 'vue-i18n'

Vue.use(VueI18n) // 通过插件的形式挂载
const i18n = new VueI18n({
    locale: navigator.language.toLowerCase(),
    fallbackLocale: 'en',
    silentFallbackWarn: true,
    messages: {
        'de': require('./config/json/de'),
        'en': require('./config/json/en'),
        'es': require('./config/json/es'),
        'fr': require('./config/json/fr'),
        'id': require('./config/json/id'),
        'ja': require('./config/json/ja'),
        'ms': require('./config/json/ms'),
        'pt': require('./config/json/pt'),
        'th': require('./config/json/th'),
        'ru': require('./config/json/ru'),
        'vi': require('./config/json/vi')
    }
})

new Vue({
    i18n,
    render: h => h(App),
}).$mount('#app')
